import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useBoolean } from '@fluentui/react-hooks';
import { Badge, Button, Label, Subtitle1 } from '@fluentui/react-components';
import { Separator } from '@fluentui/react';

// Model imports

// Functions imports
import * as ComponentFunctions from './PractitionerConsumptionToSettle.Functions';

// Component imports
import SettlementFormComponent from '../../../Settlements/SettlementForm/Settlement.Form.Component';

// Styles
import './PractitionerConsumptionToSettle.Styles.css';

const PractitionerConsumptionToSettleComponent = (props: ComponentFunctions.Props) => {
    const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] = useBoolean(false);

    useEffect(() => {
        if (props.practitioner?.userId !== undefined) {
            props.GetPractitionerConsumptionsToSettle(props.practitioner.userId);
        }
    }, [props.practitioner?.userId, props.Consumptions?.length]);

    const handleClosePanel = () => {
        dismissPanel();
    };

    const Forms = (
        <SettlementFormComponent
            isOpen={isOpen}
            dismissPanel={handleClosePanel}
            openPanel={openPanel}
            ContractId={undefined}
            PractitionerId={props.PractitionerId}
            ProtocolId={undefined}
            MedicalAgreementId={undefined}
            MedicalInsuranceId={undefined}
        />
    );

    return (
        <div className='PractitionerConsumptionToSettleContainer'>
            <div>
                {props.TotalByCurrency?.map((total) =>
                    <div key={total.Currency}>
                        <Label>Total</Label>
                        <Subtitle1>{total.Total?.toLocaleString('es-AR', { style: 'currency', currency: total.Currency.toUpperCase() }) ?? '0.00'}</Subtitle1>
                    </div>
                )}
            </div>
            <Separator vertical />
            <div>
                <Button onClick={openPanel}>Generar Liquidación&nbsp;<Badge>{props.Consumptions.length}</Badge></Button>
            </div>
            {Forms}
        </div>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(PractitionerConsumptionToSettleComponent as any);
